import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useState } from "react";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export default () => {
  const [open, setOpen] = useState(false);

  const back = useCallback(async () => {
    await RpcMpProvider.getInstance().callClient(
      RegionShared.Client.Events.Auth.AuthStartSession,
      {},
    );
  }, []);

  const openHandler = useCallback(() => {
    setOpen(true);
  }, []);

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    back,
    openHandler,
    closeHandler,
  };
};
